import { motion } from "framer-motion";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 85%;
  align-items: center;
  gap: 24px;
  position: relative;
  background: rgba(0, 6, 22, 0.6);
`;

export const GroupContainer = styled(motion.div)<{ $error?: boolean }>`
  width: 100%;
  border: 1px solid
    ${({ theme, $error }) =>
      $error ? theme.THEME.error || "#ff4d4f" : theme.THEME.grayText};
  border-radius: 12px;
  padding: 16px;
  position: relative;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`;

export const Label = styled.label<{ $error?: boolean }>`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  color: ${({ theme, $error }) =>
    $error ? theme.THEME.error || "#ff4d4f" : theme.THEME.white};
  font-family: "Sora", sans-serif;
  margin-bottom: 4px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const Input = styled.input<{ $error?: boolean }>`
  background: transparent;
  border: none;
  border-bottom: 1px solid
    ${({ theme, $error }) =>
      $error ? theme.THEME.error || "#ff4d4f" : theme.THEME.grayText};
  color: ${({ theme }) => theme.THEME.white};
  padding: 6px 4px;
  font-family: "Inter", sans-serif;
  font-size: clamp(16px, ${({ theme }) => theme.CONSTANTS.XR * 26}px, 20px);

  &:focus {
    outline: none;
    border-color: ${({ theme, $error }) =>
      $error ? theme.THEME.error || "#ff4d4f" : theme.THEME.neonBlue};
    box-shadow: 0 2px 0 0
      ${({ theme, $error }) =>
        $error ? theme.THEME.error || "#ff4d4f" : theme.THEME.neonBlue};
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;

export const AddButton = styled.button`
  position: absolute;
  bottom: -40px;
  right: -10px;
  font-size: 32px;
  background: none;
  color: ${({ theme }) => theme.THEME.white};
  border: none;
  cursor: pointer;
  transition: 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.THEME.neonBlue};
    transform: scale(1.4);
  }
`;
